// SidePanel.tsx
import { Box, Stack } from '@mui/material'
import React, { PropsWithChildren } from 'react'

import SidePanelHeader, { ISidePanelHeaderProps } from './SidePanelHeader'

export interface ISidePanelProps {
  Header?: typeof SidePanelHeader
  displayHeader?: boolean
  headerProps?: ISidePanelHeaderProps
}

export function SidePanel({
  displayHeader = true,
  headerProps,
  Header: CustomHeader,
  children,
}: PropsWithChildren<ISidePanelProps>) {
  const Header = CustomHeader ?? SidePanelHeader

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
        width: '100%',
        minWidth: 250,
        maxWidth: 300,
      }}
      data-testid="filter-panel"
    >
      {displayHeader && <Header {...headerProps} />}
      <Stack height={'100%'} sx={{ overflowY: 'auto', overflowX: 'hidden' }} useFlexGap>
        {children}
      </Stack>
    </Box>
  )
}
